// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expandable-content[data-v-bca024ac]{display:flex;flex-wrap:wrap;font-size:1.4rem;gap:16px;line-height:2rem;overflow:hidden;transition:height .3s ease}.expandable-content.expanded[data-v-bca024ac]{height:auto!important}.toggle-button[data-v-bca024ac]{cursor:pointer;margin:20px 0 4px;-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
